import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Device, DeviceAssignment } from '@/types';

interface DeviceState {
  activeDeviceId: string | null;
  activeDevice: Device | null;
  assignments: DeviceAssignment[];
  visibleDeviceName: string | null;
  setActiveDevice: (device: Device) => void;
  setAssignments: (assignments: DeviceAssignment[]) => void;
  setVisibleDeviceName: (name: string | null) => void;
  clearDevice: () => void;
}

export const useDeviceStore = create<DeviceState>()(
  persist(
    (set) => ({
      activeDeviceId: null,
      activeDevice: null,
      assignments: [],
      visibleDeviceName: null,
      setActiveDevice: (device) =>
        set({ activeDeviceId: device.id, activeDevice: device }),
      setAssignments: (assignments) => set({ assignments }),
      setVisibleDeviceName: (name) => set({ visibleDeviceName: name }),
      clearDevice: () =>
        set({ activeDeviceId: null, activeDevice: null }),
    }),
    {
      name: 'ziplink-access-device',
      partialize: (state) => ({
        activeDeviceId: state.activeDeviceId,
      }),
    }
  )
);
